let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("a0IS8"), load("7mNcY"), load("aiceI"), load("ffEVr"), load("3CJXT")]).then(() => parcelRequire('hGU26'));